import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';
import store from '../../store';
import {setProductModel} from '../../slices/configurationSlice';
import {widgetButton} from '../../css/styleSets';

@customElement('model-select-item')
export class ModelSelectItem extends connect(store)(LitElement) {

	static styles = [
		widgetButton,
		css`
			:host {
			}
		`];

	@property({type: Object})
	model = {};

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.modelTranslations = state.productData.modelTranslations;
		this.lang = state.status.lang;
		this.productModel = state.configuration.data.projects[0].project.productModelId;
	}

	isSelected() {
		return this.model.productModelId === this.productModel;
	}

	setModel() {
		store.dispatch(setProductModel(
			{
				productModel: this.model.productModelId
			}
		));
	}

	getLabel() {
		const key = this.lang + '.' + this.model.productModelId;
		return (this.modelTranslations && key in this.modelTranslations) ? this.modelTranslations[key].text : '[' + this.model.productModelId + ']';
	}

	render() {
		return html`
			<div class="item ${classMap({selected: this.isSelected(), disabled: false})}">
				<button @click="${this.setModel}">
					${this.getLabel()}
				</button>
			</div>
		`;
	}
}
